const loadedStyles = {};

/**
 * Dynamically loads a CSS file and tracks its state.
 *
 * @param {string} url - The URL of the CSS file to load.
 * @returns {Promise<void>} - Resolves when the stylesheet is loaded, rejects on error.
 */
export function loadCss(url) {
    if (loadedStyles[url]?.loaded) {
        return Promise.resolve();
    }

    if (loadedStyles[url]?.inProgress) {
        return loadedStyles[url].promise;
    }

    const cssPromise = new Promise((resolve, reject) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;

        link.onload = () => {
            loadedStyles[url] = { loaded: true, inProgress: false };
            resolve();
        };

        link.onerror = () => {
            loadedStyles[url] = { loaded: false, inProgress: false };
            reject(new Error(`Failed to load CSS: ${url}`));
        };

        document.head.appendChild(link);
    });

    loadedStyles[url] = {
        inProgress: true,
        loaded: false,
        promise: cssPromise,
    };

    return cssPromise;
}
